import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { CardBackgroundComponent } from '../../card-background.component';
import { FireAndFlowerDefaultCardStackBackgroundViewModel } from './fire-and-flower-default-card-stack-background-view-model';
import { CardData } from '../../../../../../../models/print-cards/card-data';

@Component({
  selector: 'app-fire-and-flower-default-card-stack-background',
  templateUrl: './fire-and-flower-default-card-stack-background.component.html',
  styleUrls: ['./fire-and-flower-default-card-stack-background.component.scss'],
  providers: [FireAndFlowerDefaultCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FireAndFlowerDefaultCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public override viewModel: FireAndFlowerDefaultCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: CardData;
}
